module.exports = __webpack_public_path__ + "img/7_48.979665d2.png";